import { render, staticRenderFns } from "./RunnitSideNavAccountCard.vue?vue&type=template&id=2b29d1ca&scoped=true"
import script from "./RunnitSideNavAccountCard.vue?vue&type=script&lang=ts"
export * from "./RunnitSideNavAccountCard.vue?vue&type=script&lang=ts"
import style0 from "./RunnitSideNavAccountCard.vue?vue&type=style&index=0&id=2b29d1ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b29d1ca",
  null
  
)

export default component.exports